import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";

// Components
import { blobURL } from "common/StringUtils";
import Layout from "../Layout";
import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";

const PensionInsurance = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const sppPDF = `${blobURL}/Tjänstepension.pdf`;

  const user = useSelector((state) => state.auth.user);

  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const Pension = () => {
    return (
      <>
        <Helmet>
          <title>{t("Pension | Invozio")}</title>

          {language === LOCALES.EN_US ? (
            <link rel="canonical" href="https://invozio.com/pension" />
          ) : (
            <link rel="canonical" href="https://invozio.com/pension" />
          )}
          <meta name="robots" content="index, follow" />
        </Helmet>
        <Container className="p-0 self_new negotiate neg_rspn health-insurance-top-section">
          <header>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 px-md-5 px-sm-3 px-4">
                  <h1 className="purple">
                    {t(
                      "Occupational Pension with Invozio – Saving for a Secure Future"
                    )}
                  </h1>
                  <p>
                    {t(
                      "At Invozio, we have chosen to partner with SPP for our occupational pension solutions. SPP offers a modern and sustainable pension savings plan with low fees and a wide range of investment options, allowing freelancers and consultants to save for their future in a secure and flexible way."
                    )}
                  </p>
                  <p>
                    {t(
                      "The occupational pension is one of the most important parts of long-term financial planning, and through our collaboration with SPP, we can provide our users with a smooth and beneficial solution."
                    )}
                  </p>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="healthhero-image">
                    <img alt="" src="/assets/dashboard-pension-banner.png" />
                  </div>
                </div>
              </div>
            </div>
          </header>

          <main>
            <section className="guide-section bg-white">
              <div className="container">
                <div className="py-3">
                  <div className="row align-items-center">
                    <div className="">
                      <div className="page-heading">
                        <h2 className="purple">
                          {t("Benefits of Occupational Pension via Invozio and SPP")}
                        </h2>
                        <ul>
                          <li style={{ padding: 0 }}>
                            ✔ {t(
                              "Low fees – More of your savings go directly towards your pension."
                            )}
                          </li>
                          <li style={{ padding: 0 }}>
                            ✔ {t(
                              "Flexibility – At each invoicing occasion, you can voluntarily choose to allocate between SEK 1,000 and SEK 3,000 to your occupational pension."
                            )}
                          </li>
                          <li style={{ padding: 0 }}>
                            ✔ {t(
                              "Wide range of funds – Access to a diverse selection of investment funds, including sustainable investment options."
                            )}
                          </li>
                          <li style={{ padding: 0 }}>
                            ✔ {t(
                              "Security – SPP is one of Sweden’s leading providers of pension savings solutions."
                            )}
                          </li>
                        </ul>
                        <h2 className="purple">
                          {t(
                            "Why is Occupational Pension Important for Freelancers and Consultants?"
                          )}
                        </h2>
                        <p>
                          {t(
                            "As a freelancer or consultant, you do not automatically receive the same pension benefits as traditionally employed individuals. Therefore, it is especially important to take control of your pension savings. By saving regularly in an occupational pension, you ensure a stable financial future and build long-term capital."
                          )}
                        </p>

                        <h2 className="purple">{t("How to Save for Your Occupational Pension via Invozio:")}</h2>
                        <p>
                        • {t(
                            "Log in to Invozio’s platform."
                          )}
                        </p>

                        <p>
                        • {t(
                            "Choose whether you want to save for your occupational pension when invoicing. You can allocate between SEK 1,000 and SEK 3,000 per invoice."
                          )}
                        </p>

                        <p>
                        • {t(
                            "If you don’t want to save for your pension on a specific invoice, you can simply skip it."
                          )}
                        </p>
                        <p>
                        • {t("SPP manages your savings, and you can log in at any time to track progress, switch funds, or adjust your savings plan.")}
                        <a
                            className="ml-1"
                            target="_blank"
                            href={sppPDF}
                            style={{ textDecoration: "underline" }}
                            rel="noopener noreferrer"
                          >
                            <strong>{t("Click here")}</strong>
                          </a>                        </p>
                        <p>
                          {t("Our collaboration with SPP is conducted through our partner, the accounting firm Tallypro AB (Org. no: 559020-3328). Please note that it may take up to 60 days from the date your invoice is paid and you receive your payslip before your pension contribution appears in your SPP account. If you have any questions about your occupational pension or need assistance, you are always welcome to contact us at support@invozio.com.")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </Container>
      </>
    );
  };

  return (
    <>
      {user ? (
        <Layout className="my-customers-table" showSidebar bgcolor>
          {Pension()}
        </Layout>
      ) : (
        <Layout
          className="p-0 my-customers-table"
          dashboardFooter={dashboardFooter}
        >
          {Pension()}
        </Layout>
      )}
    </>
  );
};

export default PensionInsurance;
